export default __webpack_public_path__ + "static/media/Rachelle_Caco_AHV_In_Moms_We_Trust.ae170c3a.jpg";